import * as ngCore from '@angular/core'
import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'

import { AtnDsTableStore } from '../../../../store'

@ngCore.Component({
  selector: 'clipboard-action',
  styleUrl: './component.scss',
  template: `
  @let shouldPresentCopyIcon = shouldPresentCopyIconSg();
  @let shouldPresentPasteIcon = shouldPresentPasteIconSg();
  @if (shouldPresentCopyIcon || shouldPresentPasteIcon) {
    <div class="clipboard-actions">
      @if (shouldPresentPasteIcon) {
          <i
            class="atn-icon atn-paste atn-blue"
            (click)="pasteIconClickHandler($event)"
          ></i>
        }
      @if (shouldPresentCopyIcon) {
          <i
            class="atn-icon atn-copy atn-blue"
            (click)="copyIconClickHandler()"
          ></i>
        }
    </div>
  }
  `,
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  public readonly store = ngCore.inject(AtnDsTableStore)

  /**
   * Are there any items selected to copy, under the current selection target?
   *
   * @see {@link _pluginSg}, {@link _selectionTargetSg}
   */
  public readonly shouldPresentCopyIconSg = ngCore.computed(
    (
      plugin = this.store.clipboardPluginSg(),
      selectionTarget = this.store.selectionTargetSg(),
      selectedIds = plugin?.collection.plugins.selectionPlugin.applied.selectors
        .getFromSelectionLookup(selectionTarget)
        .asSignal(),
    ) => !!selectedIds?.length,
  )

  /**
   * Only present if there is a selection to paste.
   */
  public readonly shouldPresentPasteIconSg = ngCore.computed(
    (plugin = this.store.clipboardPluginSg()) =>
      !!plugin?.feature.selectors.canPaste.asSignal(),
  )

  /**
   * Copy selected items.
   */
  public copyIconClickHandler() {
    const plugin = this.store.clipboardPluginSg()
    plugin?.feature.actions.copySelected
      .from('Table.WidgetActions.Icons.Copy.Clicked')
      .dispatch()
  }

  /**
   * Opens a paste for given feature (for this table entity type.)
   */
  public pasteIconClickHandler($event: Event) {
    const plugin = this.store.clipboardPluginSg()
    plugin?.feature.actions.paste
      .from('Table.WidgetActions.Icons.Paste.Clicked')
      .dispatch({
        dialogConfig: {
          offset: {
            x: 0,
            y: 34,
          },
          originPosition: clipboard.models.Coordinates.from($event),
        },
      })
  }
}
